/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContinueWithRecoveryUiFlow } from './continueWithRecoveryUiFlow';


/**
 * Indicates, that the UI flow could be continued by showing a recovery ui
 */
export interface ContinueWithRecoveryUi { 
    /**
     * Action will always be `show_recovery_ui` show_recovery_ui ContinueWithActionShowRecoveryUIString
     */
    action: ContinueWithRecoveryUi.ActionEnum;
    flow: ContinueWithRecoveryUiFlow;
}
export namespace ContinueWithRecoveryUi {
    export type ActionEnum = 'show_recovery_ui';
    export const ActionEnum = {
        ShowRecoveryUi: 'show_recovery_ui' as ActionEnum
    };
}


